import React, { useState } from "react";
import axios from "axios";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { toast } from "react-toastify";
import { ADMIN_SIGNIN } from "../../../api/api";
import { FaEye, FaEyeSlash } from "react-icons/fa";

// import "./AdminSignin.css";

import signinImg from "../../../assets/loginpage-image.png";
import logo from "../../../assets/Skilledition-logo.png";

const AdminSignin = () => {
  const [adminSignin, setAdminSignin] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [adminLoading, setAdminLoading] = useState(false);

  const navigate = useNavigate();

  // main toast error
  const showErrorToast = (message) => {
    toast.error(message, {
      position: "top-right",
      autoClose: 1500,
      theme: "colored",
    });
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdminSignin((prev) => ({ ...prev, [name]: value }));
  };

  const togglePassword = () => setShowPassword((prev) => !prev);

  const handleSigninSubmit = async (e) => {
    e.preventDefault();
    setAdminLoading(true);

    const payload = {
      email: adminSignin.email,
      password: adminSignin.password,
    };

    try {
      const response = await axios.post(ADMIN_SIGNIN, payload);

      const data = response.data;

      if (data.statusCode === 200) {
        toast.success(data.message || "Login successful!", {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
        });

        // Store only token and user_id
        localStorage.setItem("token", data.token);
        localStorage.setItem("user_id", data.user.user_id);
        localStorage.setItem("userRole", data.user.role);

        setTimeout(() => {
          navigate("/header/admin/dashboard");
        }, 1500);
      } else {
        showErrorToast(data.message || "Login failed!");
      }
    } catch (error) {
      console.error("Signin Error:", error);
      // Clear password field
      setAdminSignin((prev) => ({ ...prev, password: "" }));

      if (error.response?.data?.message) {
        // Server responded with non-2xx status (like 409)
        showErrorToast(error.response.data?.message);
      } else {
        showErrorToast("Network error! Please try again.");
      }
    } finally {
      setAdminLoading(false);
    }
  };

  return (
    <section className="student-signin-section">
      <Container className="student-signin-container">
        <Row className="student-signin-row">
          {/* Left Side - signin Form */}
          <Col xs={12} md={6} className="student-signin-left">
            <div className="student-signin-content">
              <div className="student-signin-logo mb-4">
                <img src={logo} alt="Skilledition Logo" />
              </div>
              <h5 className="student-signin-title">Welcome Back, Admin</h5>
              <p className="student-signin-subtitle mb-3">
                Securely sign in to manage the Skilledition platform and oversee
                all administrative operations.
              </p>

              {/* Email/Password Form */}
              <Form
                className="student-signin-form"
                onSubmit={handleSigninSubmit}
              >
                <Form.Group
                  controlId="email"
                  className="student-signin-form-group"
                >
                  <Form.Label className="student-signin-label">
                    Email
                  </Form.Label>
                  <Form.Control
                    type="email"
                    name="email"
                    placeholder="Enter your email"
                    className="student-signin-input"
                    value={adminSignin.email}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>

                <Form.Group
                  controlId="password"
                  className="student-signin-form-group"
                >
                  <Form.Label className="student-signin-label">
                    Password
                  </Form.Label>

                  <div className="student-signin-password-input-wrapper">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter your password"
                      className="student-signin-input"
                      value={adminSignin.password}
                      onChange={handleChange}
                      required
                    />
                    <span
                      className="student-signin-password-toggle-icon"
                      onClick={togglePassword}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                </Form.Group>

                <Button
                  type="submit"
                  className="student-signin-btn mt-2"
                  disabled={adminLoading}
                >
                  {adminLoading ? "Signing in..." : "Sign In"}
                </Button>
              </Form>
            </div>
          </Col>

          {/* Right Side - Image Section */}
          <Col xs={12} md={6} className="student-signin-right d-none d-md-flex">
            <div className="student-signin-right-content">
              <h2 className="student-signin-right-title">
                Complete Control. One Dashboard.
              </h2>

              <p className="student-signin-right-desc">
                Manage courses, tutors, students, and platform activities from
                one place.
              </p>

              <img
                src={signinImg}
                alt="signin Visual"
                className="student-signin-image"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AdminSignin;
